import React from 'react';

import { useAppInfo } from '../hooks/useAppInfo';
import { Checkbox } from 'case-web-ui';
import { useDispatch } from 'react-redux';
import { setSelectedLanguages } from '../store/appSlice';
import { useAvailableLanguages } from '../hooks/useAvailableLanguages';
import { Language } from '../api/types/config';
import { Button } from 'react-bootstrap';
import { Icon } from './ui';
import { getLogoutURL } from '../api/appAPI';

interface UserInfoComponentProps {
};

interface LanguageSelectorProps {
    selectedLanguages: Array<string>;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = (props) => {

    const dispatch = useDispatch();

    const availableLanguages = useAvailableLanguages();

    const update = (lang:string, value:boolean) =>{
       
        var languages: Array<string> = props.selectedLanguages;
        if(value) {
            if( !props.selectedLanguages.includes(lang)) {
                languages = props.selectedLanguages.concat([lang]);
            }
        } else {
            languages = props.selectedLanguages.filter(v=>!(v === lang));
        } 
        dispatch(setSelectedLanguages(languages));
    };

    const selector = (lang: Language) => {
        const checked = props.selectedLanguages.includes(lang.code);
        
        return <Checkbox 
                    key={lang.code}
                    id={'lang-' + lang.code} 
                    label={lang.label}
                    name="language-selector" 
                    checked={checked} 
                    onChange={(v:boolean)=> { update(lang.code, v)}
        }/>
    }

    return <ul>
     { availableLanguages.map(selector) }
    </ul>

}

 
export const UserInfo: React.FC<UserInfoComponentProps> = (props) => {
  const doLogout = () => {
     document.location = getLogoutURL();
  }
   const appInfo = useAppInfo();
   return ( 
    <div>
     <span>{ appInfo.auth?.username }</span>
     <LanguageSelector selectedLanguages={appInfo.selectedLanguages}/> 
     <Button onClick={doLogout}><Icon name="logout"/> Logout</Button>
    </div>
   )
}
 


